import { ITagResult } from '~src/httpClient/serverApi/types/IResponse';
import TagHttpClient from '~src/httpClient/TAG/TagHttpClient';
import { TagRequest } from '~src/httpClient/TAG/TagRequest';
import { AuthenticationType } from '~src/settings/types/IServerSettingsUnauthenticated';

import { IIdentityPool } from '../../types/identityPools/IIdentityPool';

export interface ListIdentityPoolsParams {
}

interface ITagIdentityPool {
  identity_pool_id: {
    value: string;
  };
  identity_pool_name: string;
  description?: string;
  identity_store_instance_id: number;
  auth_type_instance_id: number;
  is_enabled: boolean;
  identity_store_type: string;
  created_at: Date;
  updated_at: Date;
  auth_type: AuthenticationType;
}

interface IdentityPoolsTagResult {
  pools?: ITagIdentityPool[];
}


class ListIdentityPoolsRequest extends TagRequest<ListIdentityPoolsParams,  ITagResult & IdentityPoolsTagResult> {
  constructor(params: ListIdentityPoolsParams) {
    super('authn', 'ListIdentityPools', params);
  }
}

interface IdentityPoolsResult {
  identityPools?: IIdentityPool[];
}

export type IListIdentityPoolsResult = ITagResult & IdentityPoolsResult;

export function listIdentityPools(): Promise<IListIdentityPoolsResult> {
  return TagHttpClient.sendTagRequest(new ListIdentityPoolsRequest({})).then((result: ITagResult & IdentityPoolsTagResult) => {
      return {...result,
        identityPools: result.pools ? result.pools.map(fromTagPoolToIdentityPool) : []
      };
  });
}

function fromTagPoolToIdentityPool(tagPool: ITagIdentityPool): IIdentityPool {
  return {
    id: tagPool.identity_pool_id.value,
    name: tagPool.identity_pool_name,
    identityStoreInstanceId: tagPool.identity_store_instance_id,
    description: tagPool.description,
    enabled: tagPool.is_enabled,
    identityStoreType: tagPool.identity_store_type,
    createdAt: tagPool.created_at,
    updatedAt: tagPool.updated_at,
    authType: tagPool.auth_type
  };
}
